import React, { useContext } from "react";
import { Col, Container, Input, Label, Row } from "reactstrap";
import FooterContext from "../../../context/FooterContext/FooterContext";
import { maxLengthCheck } from "../../../../utils/helper";
import { options } from "../../../constant";
import Select from "react-select";

const FooterTwo = () => {
  const { isEdit, footerTwoForm, setFooterTwoForm } = useContext(FooterContext);
  /**
   * input value change
   * @param {event} e
   */
  const changeFormValue = (e) => {
    const { value, name } = e.target;
    setFooterTwoForm((prev) => {
      let updatedData = {
        ...prev,
        [name]: value,
      };
      return updatedData;
    });
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center ">
              <h6>{isEdit ? "Edit" : "Add New"}</h6>
              <Row>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">DialCode 1</Label>
                  <Select
                    style={{ width: "125px" }}
                    options={options}
                    name="dialCode1"
                    isSearchable={true}
                    value={footerTwoForm.dialCode1}
                    onChange={(prev) =>
                      setFooterTwoForm((prevValue) => {
                        return {
                          ...prevValue,
                          dialCode1: prev,
                        };
                      })
                    }
                  />
                </Col>
                <Col md="9 mb-3">
                  <Label htmlFor="validationCustom03">Phone 1</Label>
                  <Input
                    className="form-control"
                    name="phone1"
                    type="number"
                    placeholder="Phone 1"
                    value={footerTwoForm?.phone1}
                    onChange={(e) => changeFormValue(e)}
                    min={"0"}
                    maxLength={10}
                    onInput={maxLengthCheck}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col md="3 mb-3">
                  <Label htmlFor="validationCustom03">DialCode 2</Label>
                  <Select
                    style={{ width: "125px" }}
                    options={options}
                    name="dialCode2"
                    isSearchable={true}
                    value={footerTwoForm.dialCode2}
                    onChange={(prev) =>
                      setFooterTwoForm((prevValue) => {
                        return {
                          ...prevValue,
                          dialCode2: prev,
                        };
                      })
                    }
                  />
                </Col>
                <Col md="9 mb-3">
                  <Label htmlFor="validationCustom03">Phone 2</Label>
                  <Input
                    className="form-control"
                    name="phone2"
                    type="number"
                    placeholder="Phone"
                    value={footerTwoForm?.phone2}
                    onChange={(e) => changeFormValue(e)}
                    min={"0"}
                    maxLength={10}
                    onInput={maxLengthCheck}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Email 1</Label>
                  <Input
                    className="form-control"
                    name="email1"
                    type="email"
                    placeholder="Email 1"
                    value={footerTwoForm?.email1}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Email 2</Label>
                  <Input
                    className="form-control"
                    name="email2"
                    type="email"
                    placeholder="Email 2"
                    value={footerTwoForm?.email2}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">Address</Label>
                  <textarea
                    className="form-control"
                    name="address"
                    type="text"
                    placeholder="address"
                    cols={5}
                    value={footerTwoForm?.address}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FooterTwo;
